<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="datasets"
      :search="search"
      :items-per-page="30"
      :footer-props="{
        itemsPerPageOptions: [15, 30, -1],
        itemsPerPageText: $t('table.itemsPerPageText')
      }"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('search')" single-line hide-details />
          <v-spacer />
          <v-btn color="primary" to="/manage/edit/datasets/add"><v-icon left>mdi-plus</v-icon>{{ $t("button.newItem") }}</v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.access_type="{ item }">{{ $t(`form.dataset_access_types.${item.access_type}`) }}</template>
      <template v-slot:item.licenses="{ item }">{{ licenseNames(item.licenses) }}</template>
      <template v-slot:item.responsible="{ item }">{{ responsiblePersonName(item) }}</template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon color="primary" :to="`/manage/edit/datasets/edit/${item.id}`"><v-icon>mdi-pencil</v-icon></v-btn>
        <v-btn icon color="error" @click="deleteItem(item)"><v-icon>mdi-delete</v-icon></v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import axios from "axios";
export default {
  name: "EditDatasetList",
  data: () => ({ search: "", datasets: [], licenses: [], people: [] }),
  computed: {
    headers() {
      return [
        { text: this.$t("form.dataset_title"), value: "title" },
        { text: this.$t("table.responsible"), value: "responsible" },
        { text: this.$t("form.dataset_access_type"), value: "access_type" },
        { text: this.$t("form.dataset_licenses"), value: "licenses" },
        { text: this.$t("form.dataset_publication_date"), value: "publication_date" },
        { text: this.$t("actions"), value: "actions", sortable: false, align: "end" }
      ];
    }
  },
  created() { this.load(); },
  methods: {
    load() {
      Promise.all([
        axios.get(`${this.$store.state.endpoint}/dataset`),
        axios.get(`${this.$store.state.endpoint}/dataset/licenses`),
        axios.get(`${this.$store.state.endpoint}/personName`)
      ]).then(([datasets, licenses, people]) => {
        this.datasets = datasets.data;
        this.licenses = licenses.data;
        this.people = people.data;
      });
    },
    personFullName(personReference) {
      if (!personReference) {
        return "";
      }
      const person = personReference.person || personReference;
      if (person.preferred_name) {
        const given = person.preferred_name.given_name || "";
        const family = person.preferred_name.family_name || "";
        return `${given} ${family}`.trim();
      }
      const personId = person.id !== undefined ? person.id : personReference;
      const match = this.people.find(item => String(item.id) === String(personId));
      if (!match || !match.preferred_name) {
        return "";
      }
      return `${match.preferred_name.given_name || ""} ${match.preferred_name.family_name || ""}`.trim();
    },
    responsiblePersonName(item) {
      return this.personFullName(item && item.responsible_person) || "-";
    },
    licenseNames(ids) {
      return (ids || []).map(id => {
        const license = this.licenses.find(item => String(item.value) === String(id));
        return license ? license.label : "";
      }).filter(Boolean).join(", ");
    },
    deleteItem(item) {
      if (!confirm(this.$t("message.confirm.delete"))) return;
      axios.delete(`${this.$store.state.endpoint}/dataset/${item.id}`).then(() => {
        this.datasets = this.datasets.filter(dataset => dataset.id !== item.id);
      });
    }
  }
};
</script>
